import React from "react"
import { useNavigate } from "react-router-dom"

import Project from "./Project/Project"
import Button from "../button/Button"

import { Wrapper, Content } from "./Projects.styles"

// data for 1 project
import { TopProjects } from "../../Data"

const Projects = () => {
  const navigate = useNavigate()

  const GoToProjectsPage = () => {
    navigate("/projects");
  }

  return (
    <Wrapper>
      <Content>
        <h1>My Projects</h1>
        {TopProjects.map((project, index) => (
          <Project
            key={index}
            project={project}
            position={index % 2 === 1 ? "reversed" : "normal"}
          />
        ))}
        <Button
          type="button"
          text="More Projects"
          callback={GoToProjectsPage}
        />
      </Content>
    </Wrapper>
  )
}

export default Projects
